<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" (click)="goToHome()"><img src="assets/img/logo.png" style="cursor: pointer"></a>

    <div class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" (click)="goToProposal()">
            <app-nav-link [text]="'newOrder.navigation.hechtProposal'"></app-nav-link>
        </li>
        <li class="nav-item" (click)="goToTrialLens()">
            <app-nav-link [text]="'newOrder.navigation.trialLens'"></app-nav-link>
        </li>
        <li class="nav-item" (click)="goToFinalLens()">
            <app-nav-link [text]="'newOrder.navigation.finalLens'"></app-nav-link>
        </li>
        <li class="nav-item" (click)="goToCare()">
            <app-nav-link [text]="'newOrder.navigation.care'"></app-nav-link>
        </li>
        <li class="nav-item" (click)="goToAccessories()">
          <app-nav-link [text]="'newOrder.navigation.accessories'"></app-nav-link>
        </li>
        <li class="nav-item" (click)="goToConfirm()">
          <app-nav-link [text]="'newOrder.popup.addTitle'"></app-nav-link>
        </li>
        <li class="nav-item" [ngClass]="(isEnglish()) ? 'margin-app-cart-en' : 'margin-app-cart-de'">
          <app-cart></app-cart>
        </li>
        <li class="nav-item ml-4">
          <app-language-picker></app-language-picker>
        </li>
      </ul>
    </div>

</nav>
